// Footer Component
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/utils/constants";

const BIDZUU_APP_ICON = "https://customer-assets.emergentagent.com/job_auction-plaza-1/artifacts/z7a3i0nc_icon.png";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src={LOGO_URL} alt="BidZuu" className="h-28 w-auto" />
            </Link>
            <p className="text-slate-400 max-w-md">
              The global marketplace for buying, selling, and bidding on amazing items. 
              Join our community and discover treasures from around the world.
            </p>
            
            {/* App Download Section */}
            <div className="mt-6">
              <p className="text-sm text-slate-400 mb-3">Get the BidZuu App</p>
              <div className="flex items-center gap-4">
                <img 
                  src={BIDZUU_APP_ICON} 
                  alt="BidZuu App" 
                  className="h-16 w-16 rounded-xl shadow-lg"
                />
                <div className="flex flex-col gap-2">
                  <a 
                    href="https://apps.apple.com/us/app/bidzuu/id6752724318" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition-colors"
                  >
                    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                    </svg>
                    <span className="text-xs">App Store</span>
                  </a>
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.bidzuu.app" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition-colors"
                  >
                    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
                    </svg>
                    <span className="text-xs">Google Play</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Marketplace</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/browse" className="hover:text-white transition-colors">Browse Items</Link></li>
              <li><Link to="/browse?type=auction" className="hover:text-white transition-colors">Live Auctions</Link></li>
              <li><Link to="/map" className="hover:text-white transition-colors">Global Map</Link></li>
              <li><Link to="/sell" className="hover:text-white transition-colors">Start Selling</Link></li>
            </ul>
          </div>
          
          {/* Categories */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Popular Categories</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/browse?category=electronics" className="hover:text-white transition-colors">Electronics</Link></li>
              <li><Link to="/browse?category=fashion" className="hover:text-white transition-colors">Fashion</Link></li>
              <li><Link to="/browse?category=collectibles" className="hover:text-white transition-colors">Collectibles</Link></li>
              <li><Link to="/browse?category=watches" className="hover:text-white transition-colors">Watches & Jewelry</Link></li>
              <li><Link to="/browse?category=art" className="hover:text-white transition-colors">Art</Link></li>
              <li><Link to="/browse?category=vehicles" className="hover:text-white transition-colors">Vehicles</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={BIDZUU_APP_ICON} alt="BidZuu App" className="h-10 w-10 rounded-lg" />
            <span className="text-slate-400 text-sm">© 2025 BidZuu. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4 text-slate-400 text-sm">
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/help" className="hover:text-white transition-colors">Help Center</Link>
            <a href="tel:+17606009970" className="hover:text-white transition-colors">+1 760-600-9970</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
